import React from "react";
import {View, Text} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {DISCOUNT_TYPES} from "../../priceWorksheet/discounstInterface";
import {getPriceWithCurrency, toFixedPrice} from "../../../misc/helpers";
import {getSubTotalPrice} from "../../priceWorksheet/discountFunctions";

const PrintDocumentDiscount = (props) => {
  const {styles, discount, discountSections, discountSection, fabricatorSettings} = props;

  const getDiscountPercentageAmount = () => {
    const grandTotal = getSubTotalPrice(discountSections, discountSection, discount, true);
    const priceTaken = grandTotal * discount.amount / 100 // for ex. 25% from 2700 = 625
    return toFixedPrice(Math.trunc(priceTaken * 100) / 100);
  };

  const discountAmount = discount.type === DISCOUNT_TYPES.price
    ? `-${getPriceWithCurrency(fabricatorSettings, toFixedPrice(discount.amount))}`
    : `(${discount.amount}%) \xa0\xa0\xa0\xa0 -${getPriceWithCurrency(fabricatorSettings, getDiscountPercentageAmount())}`;

  return (
    <View style={styles.cartItem} wrap={false}>
      <View style={styles.cartItemInfo}>
        <Text style={styles.cartItemName}>{discount.name}</Text>
        <Text style={styles.cartItemPrice}>{discountAmount}</Text>
      </View>
    </View>
  )
};

PrintDocumentDiscount.propTypes = {
  discount: PropTypes.object.isRequired,
  discountSections: PropTypes.array.isRequired,
  discountSection: PropTypes.object.isRequired,
  fabricatorSettings: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentDiscount
